import { Box, Card, CardContent, Typography } from '@mui/material';
import { SkeletonLoader } from '../../global/Common';

interface UserInfoCardProps {
  person: any;
  cardIdentifier: string;
  loading: boolean;
  primaryColor: string;
  onCardClick: () => void;
  t: (key: string) => string;
}

export const UserInfoCard = ({ person, cardIdentifier, loading, primaryColor, onCardClick, t }: UserInfoCardProps) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
    <Typography variant="h6" sx={{ mb: 1.5, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1, color: '#495057' }}>
      <i className="bx bx-credit-card" style={{ fontSize: 24, color: primaryColor }} />
      {t('pages.dashboard.loyaltyCard')}
    </Typography>
    <Card sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {loading ? (
          <SkeletonLoader count={3} />
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            <Box 
              sx={{ 
                cursor: 'pointer',
                borderRadius: 1,
                backgroundColor: '#f8f8fb',
                border: '1px solid #e9ecef',
                transition: 'all 0.2s',
                overflow: 'hidden',
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                '&:hover': {
                  backgroundColor: '#e9ecef',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                }
              }}
              onClick={onCardClick}
            >
              <Box sx={{ p: 1.5, textAlign: 'center' }}>
                <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                  {t('header.loyaltyCard') || 'Ma carte de fidélité'}
                </Typography>
                <Box
                  sx={{
                    backgroundColor: 'white',
                    p: 1,
                    borderRadius: 1,
                    display: 'inline-block',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                  }}
                >
                  <img
                    src={`https://ean.b1-ge.fr/barcode.php?encoding=EAN&scale=4&mode=png&IsNumberVisible=true&code=${cardIdentifier}`}
                    alt="Code-barres EAN"
                    style={{
                      maxWidth: '100%',
                      height: 'auto',
                      display: 'block',
                    }}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      const parent = target.parentElement;
                      if (parent) {
                        parent.innerHTML = `
                          <div style="padding: 20px; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                            <i class="bx bx-barcode" style="font-size: 36px; color: #adb5bd; margin-bottom: 8px;"></i>
                            <span style="color: #495057; font-size: 14px; font-weight: 600;">${cardIdentifier}</span>
                          </div>
                        `;
                      }
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  </Box>
);
